import React, { useState, useEffect } from "react";
import { Chart } from "react-google-charts";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";

const GeoChart = () => {
  const { dashboardData } = useSelector((s) => s.DashboardSlice);

  const [chartHeight, setChartHeight] = useState(() => {
    if (typeof window !== "undefined") {
      if (window.innerWidth < 576) return "240px";
      if (window.innerWidth < 992) return "320px";
    }
    return "420px";
  });

  useEffect(() => {
    const updateHeight = () => {
      if (window.innerWidth < 576) {
        setChartHeight("240px");
      } else if (window.innerWidth < 992) {
        setChartHeight("320px");
      } else {
        setChartHeight("420px");
      }
    };

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const chartRows = Array.isArray(dashboardData?.geo_chart_data)
    ? dashboardData.geo_chart_data.map((item) => [item.country, item.members])
    : [];

  const data = [["Country", "Members"], ...chartRows];

  const options = {
    colorAxis: { colors: ["#c7cdf0", "#586AD9", "#3A3DBB", "#2d30a0"] },
    backgroundColor: { fill: "transparent", stroke: "transparent" },
    datalessRegionColor: "#f0f1fb",
    defaultColor: "#e8eaf5",
    legend: "none",
    tooltip: { isHtml: true },
    geochartVersion: 11,
    keepAspectRatio: true,
  };

  /* top 5 countries for legend */
  const top5 = [...chartRows]
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5);

  const total = chartRows.reduce((s, r) => s + r[1], 0);

  return (
    <div className="gm-wrap">
      {/* header row */}
      <div className="gm-header">
        <div className="gm-header-left">
          <span className="gm-total-val">{total}</span>
          <span className="gm-total-lbl">Total Members Worldwide</span>
        </div>
        <div className="gm-countries-count">
          <i className="bx bx-flag"></i>
          {chartRows.length} Countries
        </div>
      </div>

      <div className="gm-body">
        {/* map */}
        <motion.div
          className="gm-chart"
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease: [0.22, 0.68, 0, 1.2] }}
        >
          <Chart
            chartType="GeoChart"
            width="100%"
            height={chartHeight}
            data={data}
            options={options}
          />
        </motion.div>

        {/* sidebar legend */}
        {top5.length > 0 && (
          <div className="gm-legend">
            <p className="gm-legend-title">Top Countries</p>
            {top5.map(([country, count], i) => {
              const pct = total > 0 ? Math.round((count / total) * 100) : 0;
              return (
                <motion.div
                  key={country}
                  className="gm-legend-item"
                  initial={{ opacity: 0, x: 16 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.07, duration: 0.3 }}
                >
                  <div className="gm-legend-top">
                    <span className="gm-legend-rank">{i + 1}</span>
                    <span className="gm-legend-country">{country}</span>
                    <span className="gm-legend-count">{count}</span>
                  </div>
                  <div className="gm-bar-bg">
                    <motion.div
                      className="gm-bar-fill"
                      initial={{ width: 0 }}
                      animate={{ width: `${pct}%` }}
                      transition={{ delay: i * 0.07 + 0.2, duration: 0.5, ease: "easeOut" }}
                    />
                  </div>
                </motion.div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default GeoChart;

